import allcompanyconfig from './../companyconfig.json';

const getCompany = () => allcompanyconfig.company;
const getAwsApiBaseUrl = () => allcompanyconfig.firebaseConfig.awsApiBaseUrl;

function getFrontendInstance() {
  const loc = globalThis.window?.location;

  if (loc) {
    const { hostname } = loc;

    if (
      hostname === 'localhost' ||
      hostname === '127.0.0.1' ||
      hostname === '[::1]'
    ) {
      return 'local';
    }

    if (hostname.includes('staging')) {
      return 'staging';
    }

    if (hostname.endsWith('.web.app') && hostname.includes('--')) {
      return 'preview';
    }

    return 'production';
  }

  if (
    process.env.NODE_ENV === 'development' ||
    process.env.NODE_ENV === 'test'
  ) {
    return 'local';
  }
  return 'production';
}

export { getCompany, getAwsApiBaseUrl, getFrontendInstance };
